var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"info-line",staticStyle:{"padding":"0 5px","font-size":"16.25px"},attrs:{"label":"","color":_vm.$vuetify.theme.dark ? '#323338' : '#e3e3e3'}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.betInfoLine)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }